import DataBaseProcessingRoutes from './DataBaseProcessingRoutes';

export default DataBaseProcessingRoutes;
